export const fetchProducts = `*[_type == "product_range" ] | order(_createdAt asc) {
      title,
      product_image {
            asset->{
              url
            }
          },
      _id,
}`;

export const fetchProjects = `*[_type == "project" ] | order(_createdAt asc)[0...3] {
      client,
      Country,
      description,
      scope,
      year,
      project_categories[]-> {
            title,
      },
      _id,
}`;

export const fetchAllProjects = `*[_type == "project" ] | order(_createdAt asc) {
      client,
      Country,
      value,
      description,
      scope,
      year,
      project_categories[]-> {
            title,
      },
      _id,
}`;

export const fetchProjectCategory = (category) => {
  const query = `*[_type == "project" && '${category}' in project_categories[]->title] | order(_createdAt asc) {
            client,
            Country,
            value,
            description,
            scope,
            year,
            project_categories[]-> {
                  title,
            },
            _id,
      }`;
  return query;
};

export const fetchArticles = `*[_type == "post" ] | order(_createdAt desc)[0...3] {
      title,
      description,
      _id,
      slug,
      cover_image {
            asset->{
              url
            }
          },
      post_categories[]-> {
            title,
      },
      publishedAt,
      content
}`;

export const fetchAllArticles = `*[_type == "post" ] | order(_createdAt desc) {
      title,
      description,
      _id,
      slug,
      cover_image {
            asset->{
              url
            }
          },
      post_categories[]-> {
            title,
      },
      publishedAt,
      content
}`;

export const searchQuery = (searchTerm) => {
  const query = `*[_type == "post" && title match '${searchTerm}*'] {
            title,
            description,
            _id,
            slug,
            cover_image {
                  asset->{
                    url
                  }
                },
            post_categories[]-> {
                  title,
            },
            publishedAt,
            content
      }`;
  return query;
};

export const fetchArticleDetail = (slug) => {
  const query = `*[_type == "post" && slug.current == '${slug}'] {
            title,
            description,
            _id,
            slug,
            cover_image {
                  asset->{
                    url
                  }
                },
            post_categories[]-> {
                  title,
            },
            publishedAt,
            content
      }`;
  return query;
};
